import { StateProvider, StateParams, StateService } from "@uirouter/angularjs";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { vsComponentName as ContractBookGridComponentName } from "./views/grid/component";
import { vsName as ContractBookDetailGridComponentName } from "./views/info/component";
import { vsComponentName as ContactBookFormComponentName } from "./views/edit/component";


export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.contactBook", {
      url: "contactbook",
      template: "<ui-view></ui-view>",
      abstract: true,
    })
    .state("main.contactBook.grid", {  
      url: "/grid",
      component: ContractBookGridComponentName,
    })
    .state("main.contactBook.Add", {
      url: "/add",
      component: ContactBookFormComponentName,
    })
    .state("main.contactBook.Info", {
      url: "/{contactbookId:int}/info",
      component: ContractBookDetailGridComponentName,
      resolve: {
        contactbookId: [
          "$stateParams",
          function ($stateParams: StateParams) {
            return $stateParams["contactbookId"];
          },
        ],
        contactBookDetail: [
          ServerUtilityName,
          "contactbookId",
          function (serverUtility: ServerUtility, $contactbookId: number) {
           return serverUtility
              .getById({
                url: `api/addressBook/AddressBook`,
                id: $contactbookId
              })
              .then((r) => r);
          },
        ],
      },
    })
    .state("main.contactBook.Edit", {
      url: "/{contactbookId:int}/edit",
      component: ContactBookFormComponentName,
      resolve: {
        contactbookId: [
          "$stateParams",
          function ($stateParams: StateParams) {
            return $stateParams["contactbookId"];
          },
        ],
        contactBook: [
          ServerUtilityName,
          "contactbookId",
          function (serverUtility: ServerUtility, $contactbookId: number) {
           return serverUtility
              .getById({
                url: `api/addressBook/AddressBook`,
                id: $contactbookId
              })
              .then((r) => r);
          },
        ],
      },
    });
    
}
routeConfig.$inject = ["$stateProvider"];
